// @module Ames.Autopilot.Autopilot
define('Ames.Autopilot.Autopilot.View'
,	[
	'ames_autopilot_autopilot.tpl'
	
	,	'Ames.Autopilot.Autopilot.SS2Model'
	
	,	'Backbone'
    ]
, function (
	ames_autopilot_autopilot_tpl
	
	,	AutopilotSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Ames.Autopilot.Autopilot.View @extends Backbone.View
	return Backbone.View.extend({

		template: ames_autopilot_autopilot_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new AutopilotModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Ames.Autopilot.Autopilot.View.Context
	,	getContext: function getContext()
		{
			//@class Ames.Autopilot.Autopilot.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
